export enum TreeNodeTypes {
    ROOT,
    GROUP,
    NODE,
    DEVICE,
    NODE_METRIC,
    NODE_METRIC_PROPERTY,
    DEVICE_METRIC,
    DEVICE_METRIC_PROPERTY,
}
